@if (cellTitle()){
    <strong class="description">{{ cellTitle() }}</strong>
}
@if (cellData() && !isDate()  && !isDateTime()){
    <span appEllipsisTooltip>{{ cellData() }}</span>
}
@if (cellData() && isDate()){
    <span appEllipsisTooltip>{{ cellData() | date: 'MM/dd/yyyy'  }}</span>
}
@if (cellData() && isDateTime()){
    <span appEllipsisTooltip>{{ cellData() | date: 'MM/dd/yyyy hh:mm a' : 'UTC' }}</span>
}

<div class="cell-content" #ref>
    <ng-content></ng-content>
</div>

@if (!ref?.children.length && !cellData()) {
    <ng-container>-</ng-container>
}
